// Version : 0.0.2
// Author : Nandhakumar
// LastAdd : 'Converted Existed Values for the Keys from Upper Case to Smaller Case'
// Modified Date : 4-12-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import GoldLoanActionTypes from './gold-loan-collection.types';
import {
	fetchGoldLoanIndexDetails,
	fetchGoldLoanIndexInfo,
	deleteGoldLoanIndex,
	fetchParticularGoldLoanIndexInfo,
	updateGoldLoanIndexCollection,
	fetchMemberGoldCollectionDetails,
} from './gold-loan-collection.service';
import {
	getGoldLoanIndexDetailsSuccess,
	getGoldLoanIndexDetailsFailure,
	getGoldLoanIndexDetailsResponseChanged,
	getGoldLoanIndexInfoSuccess,
	getGoldLoanIndexInfoFailure,
	getGoldLoanIndexInfoResponseChanged,
	deleteGoldLoanIndexSuccess,
	deleteGoldLoanIndexFailure,
	deleteGoldLoanIndexResponseChanged,
	getParticularGoldLoanIndexInfoSuccess,
	getParticularGoldLoanIndexInfoFailure,
	getParticularGoldLoanIndexInfoResponseChanged,
	updateGoldLoanIndexCollectionSuccess,
	updateGoldLoanIndexCollectionFailure,
	updateGoldLoanIndexCollectionResponseChanged,
	getMemberGoldCollectionDetailsSuccess,
	getMemberGoldCollectionDetailsFailure,
	getMemberGoldCollectionDetailsResponseChanged,
} from './gold-loan-collection.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';

/** *********************  GOLD LOAN INDEX DETAILS START  ******************** */
export function* getGoldLoanIndexDetails({ payload }: any) {
	try {
		const { loanIndexID, groupID, companyID, userLevel, userID, databaseName } = payload;
		const key = 'GetGoldLoanIndexDetailsKey';
		const jsonData = {
			GoldLoanID: loanIndexID,
			GroupID: groupID,
			MemberCompanyID: companyID,
			Level: userLevel,
			UserID: userID,
			UserRole: userLevel,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchGoldLoanIndexDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGoldLoanIndexDetailsFailure(responseData.data));
		} else {
			yield put(getGoldLoanIndexDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getGoldLoanIndexDetailsFailure(error));
	}
}

export function* resetGetGoldLoanIndexDetailsResponse() {
	yield put(getGoldLoanIndexDetailsResponseChanged());
}

export function* onGetGoldLoanIndexDetails() {
	yield takeLatest(
		GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_DETAILS_START,
		getGoldLoanIndexDetails,
	);
}

export function* onGetGoldLoanIndexDetailsResponseReset() {
	yield takeLatest(
		GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_DETAILS_RESPONSE_RESET,
		resetGetGoldLoanIndexDetailsResponse,
	);
}
/** *********************  GOLD LOAN INDEX DETAILS END ******************** */

/** *********************  GOLD LOAN INDEX INFO START  ******************** */
export function* getGoldLoanIndexInfo({ payload }: any) {
	try {
		const { goldLoanID, companyID, userLevel, userID, databaseName } = payload;
		const key = 'GetLoanInfoBasedOnGoldLoanIndexDataKey';
		const jsonData = {
			GoldLoanID: goldLoanID,
			MemberCompanyID: companyID,
			Level: userLevel,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchGoldLoanIndexInfo, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGoldLoanIndexInfoFailure(responseData.data));
		} else {
			yield put(getGoldLoanIndexInfoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getGoldLoanIndexInfoFailure(error));
	}
}

export function* resetGetGoldLoanIndexInfoResponse() {
	yield put(getGoldLoanIndexInfoResponseChanged());
}

export function* onGetGoldLoanIndexInfo() {
	yield takeLatest(GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_INFO_START, getGoldLoanIndexInfo);
}

export function* onGetGoldLoanIndexInfoResponseReset() {
	yield takeLatest(
		GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_INFO_RESPONSE_RESET,
		resetGetGoldLoanIndexInfoResponse,
	);
}
/** *********************  GOLD LOAN INDEX INFO END ******************** */

/** *********************  GOLD LOAN INDEX DELETE START  ******************** */
export function* deleteGoldLoanIndexDetails({ payload }: any) {
	try {
		const {
			loanIndexID,
			databaseName,
			companyID,
			userID,
			userName,
			loanPaidID,
			collectionDate,
			collectionPrincipal,
			collectionInterest,
			branchID,
			infogCompanyID,
		} = payload;
		const key = 'GoldLoanIndexDeleteKey';
		const jsonData = {
			GoldLoanIndexID: loanIndexID,
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			GoldLoanIndexPaidID: loanPaidID,
			CollectionDate: collectionDate,
			CollectionPrincipal: collectionPrincipal,
			CollectionInterest: collectionInterest,
			BranchID: branchID,
			InfogID: infogCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteGoldLoanIndex, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteGoldLoanIndexFailure(responseData.data));
		} else {
			yield put(deleteGoldLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteGoldLoanIndexFailure(error));
	}
}

export function* resetDeleteGoldLoanIndexResponse() {
	yield put(deleteGoldLoanIndexResponseChanged());
}

export function* onDeleteGoldLoanIndex() {
	yield takeLatest(GoldLoanActionTypes.DELETE_GOLD_LOAN_INDEX_START, deleteGoldLoanIndexDetails);
}

export function* onDeleteGoldLoanIndexResponseReset() {
	yield takeLatest(
		GoldLoanActionTypes.DELETE_GOLD_LOAN_INDEX_RESPONSE_RESET,
		resetDeleteGoldLoanIndexResponse,
	);
}
/** *********************  GOLD LOAN INDEX DELETE END ******************** */

/** *********************  GOLD LOAN INDEX INFO START  ******************** */
export function* getParticularGoldLoanIndexInfo({ payload }: any) {
	try {
		const { loanIndexID, databaseName } = payload;
		const key = 'GetParticularGoldLoanIndexKey';
		const jsonData = {
			LoanIndexID: loanIndexID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchParticularGoldLoanIndexInfo, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularGoldLoanIndexInfoFailure(responseData.data));
		} else {
			yield put(getParticularGoldLoanIndexInfoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularGoldLoanIndexInfoFailure(error));
	}
}

export function* resetGetParticularGoldLoanIndexInfoResponse() {
	yield put(getParticularGoldLoanIndexInfoResponseChanged());
}

export function* onGetParticularGoldLoanIndexInfo() {
	yield takeLatest(
		GoldLoanActionTypes.GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_START,
		getParticularGoldLoanIndexInfo,
	);
}

export function* onGetParticularGoldLoanIndexInfoResponseReset() {
	yield takeLatest(
		GoldLoanActionTypes.GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_RESPONSE_RESET,
		resetGetParticularGoldLoanIndexInfoResponse,
	);
}
/** *********************  GOLD LOAN INDEX INFO END ******************** */

/** *********************  GOLD LOAN INDEX DELETE START  ******************** */
export function* updateGoldLoanIndexCollectionDetails({ payload }: any) {
	try {
		const {
			goldLoanID,
			branchID,
			centerID,
			groupID,
			memberID,
			productID,
			funderID,
			officerID,
			outstandingPrincipal,
			duePrincipal,
			dueInerest,
			dueEMI,
			dueNo,
			amountReceived,
			collectionFrom,
			collectedBy,
			companyID,
			databaseName,
			receivedNoticeAmount,
			outstandingInterest,
			inputDenominationTwoThousandValue,
			inputDenominationFiveHundredValue,
			inputDenominationTwoHundredValue,
			inputDenominationHundredValue,
			inputDenominationFiftyValue,
			inputDenominationTwentyValue,
			inputDenominationTenValue,
			inputDenominationFiveValue,
			inputDenominationTwoValue,
			inputDenominationOneValue,
			activeTabLoanAccType,
			chequeNumber,
			receiptNumber,
		} = payload;
		const key = 'UpdateGoldLoanPaymentDetailsKey';
		const jsonData = {
			GoldLoanID: goldLoanID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			MemberID: memberID,
			ProductID: productID,
			FunderID: funderID,
			OfficerID: officerID,
			OutstandingPrincipal: outstandingPrincipal,
			DuePrincipal: duePrincipal,
			DueInerest: dueInerest,
			DueEMI: dueEMI,
			DueNo: dueNo,
			AmountReceived: amountReceived,
			CollectionFrom: collectionFrom,
			CollectedBy: collectedBy,
			CompanyID: companyID,
			DatabaseName: databaseName,
			ReceivedNoticeAmount: receivedNoticeAmount,
			OutstandingInterest: outstandingInterest,
			TwoThousand: inputDenominationTwoThousandValue,
			FiveHundred: inputDenominationFiveHundredValue,
			TwoHundred: inputDenominationTwoHundredValue,
			Hundred: inputDenominationHundredValue,
			Fifty: inputDenominationFiftyValue,
			Twenty: inputDenominationTwentyValue,
			Ten: inputDenominationTenValue,
			Five: inputDenominationFiveValue,
			Two: inputDenominationTwoValue,
			One: inputDenominationOneValue,
			TotalDenominationAmount: amountReceived,
			ActiveTabLoanAccType: activeTabLoanAccType,
			ChequeNumber: chequeNumber,
			ReceiptNumber: receiptNumber,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateGoldLoanIndexCollection, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateGoldLoanIndexCollectionFailure(responseData.data));
		} else {
			yield put(updateGoldLoanIndexCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateGoldLoanIndexCollectionFailure(error));
	}
}

export function* resetUpdateGoldLoanIndexCollectionResponse() {
	yield put(updateGoldLoanIndexCollectionResponseChanged());
}

export function* onUpdateGoldLoanIndexCollection() {
	yield takeLatest(
		GoldLoanActionTypes.UPDATE_GOLD_LOAN_INDEX_COLLECTION_START,
		updateGoldLoanIndexCollectionDetails,
	);
}

export function* onUpdateGoldLoanIndexCollectionResponseReset() {
	yield takeLatest(
		GoldLoanActionTypes.UPDATE_GOLD_LOAN_INDEX_COLLECTION_RESPONSE_RESET,
		resetUpdateGoldLoanIndexCollectionResponse,
	);
}
/** *********************  GOLD LOAN INDEX DELETE END ******************** */

/** *********************  GET MEMBER GOLD COLLECTION DETAILS START  ******************** */
export function* getMemberGoldCollectionDetails({ payload }: any) {
	try {
		const {
			searchMemberValue,
			searchMemberType,
			memberCompanyID,
			userID,
			databaseName,
			userRole,
			level,
		} = payload;
		const key = 'GetMemberGoldCollectionDetailsKey';
		const jsonData = {
			SearchMemberValue: searchMemberValue,
			SearchMemberType: searchMemberType,
			MemberCompanyID: memberCompanyID,
			UserID: userID,
			DatabaseName: databaseName,
			UserRole: userRole,
			Level: level,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchMemberGoldCollectionDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemberGoldCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getMemberGoldCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemberGoldCollectionDetailsFailure(error));
	}
}

export function* resetGetMemberGoldCollectionDetailsResponse() {
	yield put(getMemberGoldCollectionDetailsResponseChanged());
}

export function* onGetMemberGoldCollectionDetails() {
	yield takeLatest(
		GoldLoanActionTypes.GET_MEMBER_GOLD_COLLECTION_DETAILS_START,
		getMemberGoldCollectionDetails,
	);
}

export function* onGetMemberGoldCollectionDetailsResponseReset() {
	yield takeLatest(
		GoldLoanActionTypes.GET_MEMBER_GOLD_COLLECTION_DETAILS_RESPONSE_RESET,
		resetGetMemberGoldCollectionDetailsResponse,
	);
}
/** *********************  GET MEMBER GOLD COLLECTION DETAILS END ******************** */

export function* goldCollectionSaga() {
	yield all([
		call(onGetGoldLoanIndexDetails),
		call(onGetGoldLoanIndexDetailsResponseReset),
		call(onGetGoldLoanIndexInfo),
		call(onGetGoldLoanIndexInfoResponseReset),
		call(onDeleteGoldLoanIndex),
		call(onDeleteGoldLoanIndexResponseReset),
		call(onGetParticularGoldLoanIndexInfo),
		call(onGetParticularGoldLoanIndexInfoResponseReset),
		call(onUpdateGoldLoanIndexCollection),
		call(onUpdateGoldLoanIndexCollectionResponseReset),
		call(onGetMemberGoldCollectionDetails),
		call(onGetMemberGoldCollectionDetailsResponseReset),
	]);
}
